import React, { useState, useEffect, useRef } from 'react';
import { WASMProcessor } from './utils/WASMProcessor';
import FileUploader from './components/FileUploader';
import ModelLoader from './components/ModelLoader';
import Processor from './components/Processor';
import Output from './components/Output';
import Header from './components/extra/Header';
import LanguageSelector from './components/model/LanguageSelector';
import './styles/common.css';
import SideBySide from './components/extra/SideBySide';
import Credits from './components/extra/Credits';
import FeedbackForm from './components/extra/FeedbackForm';
import PremiumFeatures from './components/PremiumFeatures';

const AudioProcessor = () => {
    const [isModelLoaded, setIsModelLoaded] = useState(false);
    const [isAudioLoaded, setIsAudioLoaded] = useState(false);
    const [processor, setProcessor] = useState(null);
    const [state, setState] = useState(0);
    const [fileName, setFileName] = useState(null);
    const [isPremium, setIsPremium] = useState(process.env.REACT_APP_IS_PREMIUM === 'true' || false);
    const [userData, setUserData] = useState(null);
    const [s3Filename, setS3Filename] = useState(null);
    const [showPremiumPopup, setShowPremiumPopup] = useState(false);
    const [numSpeakers, setNumSpeakers] = useState(1);
    const [outputLines, setOutputLines] = useState([]);
    const outputRef = useRef();

    useEffect(() => {
        setProcessor(new WASMProcessor());
    }, []);

    useEffect(() => {
        if (isPremium) {
            setIsModelLoaded(true);
        }
    }, [isPremium]);

    // Callback function to receive lines from Output component
    const handleOutputLines = (lines) => {
        setOutputLines(lines);
    };

    return (
        <div>
            <PremiumFeatures showPremiumPopup={showPremiumPopup} setShowPremiumPopup={setShowPremiumPopup} userData={userData} setUserData={setUserData} isPremium={isPremium} setIsPremium={setIsPremium} />

            <Header isPremium={isPremium} />

            <ModelLoader showPremiumPopup={showPremiumPopup} setShowPremiumPopup={setShowPremiumPopup} isPremium={isPremium} state={state} setState={setState} processor={processor} success={() => setIsModelLoaded(true)} error={(err) => console.error(err)} numSpeakers={numSpeakers} setNumSpeakers={setNumSpeakers} />

            {
                state <= 3 && <>
                    <FileUploader setS3Filename={setS3Filename} isPremium={isPremium} setFileName={setFileName} isAudioLoaded={isAudioLoaded} state={state} processor={processor} success={() => setIsAudioLoaded(true)} error={(err) => console.error(err)} />
                    
                    <SideBySide gap={10}>
                        <LanguageSelector state={state}  processor={processor} />
                        <Processor s3Filename={s3Filename} isPremium={isPremium} state={state} processor={processor} />
                    </SideBySide>
                </>
            }

            <Output 
                ref={outputRef}
                fileName={fileName} 
                state={state} 
                setState={setState} 
                processor={processor} 
                isModelLoaded={isModelLoaded} 
                isAudioLoaded={isAudioLoaded} 
                numSpeakers={numSpeakers} 
                isPremium={isPremium}
                onLinesChange={handleOutputLines}
            />
            
            <FeedbackForm isPremium={isPremium} state={state} lines={outputLines} />
            <Credits />
        </div>
    );
}

export default AudioProcessor;